import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import DescriptionIcon from '@material-ui/icons/Description';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import PaperMaterial from '@material-ui/core/Paper';

import Can from '~/contexts/Can';
import { AbilityContext } from '~/contexts/Can';

import ClientInfo from './ClientInfo';
import MedicalRecords from './MedicalRecords';
import MedicalAppointments from './MedicalAppointments';
import Dependents from './Dependents';
import SusRecord from './SusRecord';
import SusService from './SusService';
import Exams from './Exams';

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 0px 0px 0px',
  },
}));

function Tabs({ idClient, loading, record, setRecord }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const ability = useContext(AbilityContext);
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <PaperMaterial>
        <TabList
          variant="scrollable"
          textColor="secondary"
          onChange={handleChange}
        >
          <Tab
            icon={<AccountCircleIcon />}
            label={t('person.tabs.profile')}
            value="1"
            disabled={ability.cannot('show', 'Peoples')}
          />
          <Tab
            icon={<DescriptionIcon />}
            label="Exames"
            value="9"
            disabled={ability.cannot('show', 'Peoples')}
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('person.tabs.medical_record')}
            value="3"
            disabled={ability.cannot('show', 'MedicalRecords')}
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('person.tabs.medical_appointments')}
            value="4"
            disabled={ability.cannot('show', 'MedicalAppointments')}
          />
          <Tab
            icon={<AssignmentIndIcon />}
            label={t('person.tabs.dependents')}
            value="5"
            disabled={ability.cannot('list', 'Dependents')}
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('person.tabs.sus_report')}
            value="7"
            disabled={
              record?.cns === null || ability.cannot('show', 'SUSRecord')
            }
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('person.tabs.sus_service')}
            disabled={
              record?.cns === null || ability.cannot('show', 'SUSService')
            }
            value="8"
          />
        </TabList>
      </PaperMaterial>

      <Can I="show" a="Peoples">
        <TabPanel className={classes.root} value="1">
          <ClientInfo
            record={record}
            setRecord={setRecord}
            loading={loading}
            idClient={idClient}
          />
        </TabPanel>
      </Can>

      <Can I="show" a="Peoples">
        <TabPanel className={classes.root} value="9">
          <Exams idClient={idClient} />
        </TabPanel>
      </Can>

      <Can I="show" a="MedicalRecords">
        <TabPanel className={classes.root} value="3">
          <MedicalRecords idClient={idClient} record={record} />
        </TabPanel>
      </Can>

      <Can I="show" a="MedicalAppointments">
        <TabPanel className={classes.root} value="4">
          <MedicalAppointments idClient={idClient} />
        </TabPanel>
      </Can>

      <Can I="list" a="Dependents">
        <TabPanel className={classes.root} value="5">
          <Dependents user={record} />
        </TabPanel>
      </Can>

      <Can I="show" a="SUSRecord">
        <TabPanel className={classes.root} value="7">
          <SusRecord clientCNS={record?.cns} idClient={idClient} />
        </TabPanel>{' '}
      </Can>

      <Can I="show" a="SUSService">
        <TabPanel className={classes.root} value="8">
          <SusService clientCNS={record?.cns} idClient={idClient} />
        </TabPanel>
      </Can>
    </TabContext>
  );
}

export default React.memo(withRouter(Tabs));
